import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { WarningIcon } from "fe-shared/src/components/Icons";
import { WARNING_COLOR } from "../../../../consts";
import { TransferListItem } from "../../../../types";

import styles from "./FlagsRenderer.module.scss";

interface Props extends ICellRendererParams {
  data: TransferListItem;
}

const FlagsRenderer = (props: Props) => {
  const { hasAutoFlag } = props.data;

  return (
    <div className={styles.flags}>
      {hasAutoFlag && <WarningIcon fillColor={WARNING_COLOR} />}
    </div>
  );
};

export default FlagsRenderer;
